import { FC } from 'react'
import { Container, Paper, Typography, Divider, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

const TermosPage: FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper sx={{ p: { xs: 3, md: 5 } }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Termos de Uso
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Última atualização: 28/04/2026
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" paragraph>
          Estes Termos regulam o acesso e uso do Portal Originei. Ao utilizar a plataforma, você
          declara que leu, compreendeu e concorda integralmente com as condições aqui descritas.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          1. Objeto
        </Typography>
        <Typography variant="body1" paragraph>
          O Portal Originei é uma plataforma B2B de gestão de operações de crédito, simulação,
          intermediação financeira e produtos correlatos, destinada a empresas e profissionais
          autorizados.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          2. Cadastro e acesso
        </Typography>
        <Typography variant="body1" paragraph>
          O acesso é nominal, identificado e atribuído por administradores. O usuário é responsável
          pela guarda das suas credenciais e pelo uso adequado dos perfis atribuídos. Compartilhamento
          de credenciais é vedado.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          3. Conduta esperada
        </Typography>
        <Typography variant="body1" paragraph>
          O usuário compromete-se a não utilizar o portal para fins ilícitos, não tentar acesso a
          dados fora do seu escopo de autorização, não realizar engenharia reversa, varreduras
          automatizadas não autorizadas ou tentativas de comprometer a integridade dos sistemas.
          Toda atividade é registrada em trilha de auditoria.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          4. Conteúdo e dados inseridos
        </Typography>
        <Typography variant="body1" paragraph>
          O usuário é responsável pela veracidade e licitude dos dados inseridos. A Originei poderá
          remover conteúdo manifestamente ilegal ou em desacordo com estes Termos.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          5. Propriedade intelectual
        </Typography>
        <Typography variant="body1" paragraph>
          O design, código-fonte, marcas e demais elementos do Portal são de propriedade da Originei
          ou licenciados a ela. O uso da plataforma não confere ao usuário direito de cópia,
          modificação ou distribuição.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          6. Disponibilidade
        </Typography>
        <Typography variant="body1" paragraph>
          A Originei envida esforços razoáveis para manter o Portal disponível, podendo realizar
          manutenções programadas com aviso prévio. Não há garantia de disponibilidade ininterrupta.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          7. Privacidade
        </Typography>
        <Typography variant="body1" paragraph>
          O tratamento de dados pessoais segue a{' '}
          <Link component={RouterLink} to="/privacidade">Política de Privacidade</Link>, parte
          integrante destes Termos.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          8. Alterações
        </Typography>
        <Typography variant="body1" paragraph>
          Estes Termos podem ser atualizados. Mudanças relevantes serão comunicadas no portal e/ou
          por e-mail.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          9. Foro
        </Typography>
        <Typography variant="body1" paragraph>
          Aplica-se a legislação brasileira. Fica eleito o foro da comarca da sede da Originei para
          dirimir controvérsias decorrentes destes Termos, com renúncia a qualquer outro.
        </Typography>
      </Paper>
    </Container>
  )
}

export default TermosPage
